import { render } from "./Production_Batches.vue?vue&type=template&id=4f4cb375&scoped=true"
import script from "./Production_Batches.vue?vue&type=script&lang=js"
export * from "./Production_Batches.vue?vue&type=script&lang=js"

import "./Production_Batches.vue?vue&type=style&index=0&id=4f4cb375&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f4cb375"]])

export default __exports__